import { render, staticRenderFns } from "./AssetTransferForm.vue?vue&type=template&id=122a4e54"
import script from "./AssetTransferForm.vue?vue&type=script&lang=js"
export * from "./AssetTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports